import React, { useState, useEffect } from "react";

import { Button } from "react-bootstrap";

import calculateClimateScore from "../../../Utilities/calculateClimate";
import "./ProfileClimateModule.css";

const ProfileClimateModule = ({
  language,
  langData,
  expandedClimate,
  setExpandedClimate,
  inventory,
}) => {
  var earthImg = null;
  let earthIcon = require("../../../Images/Icons/EarthIconWhite.svg");

  let expandClimate = document.getElementsByClassName("climateSection");

  const [climateAvg, setClimateAvg] = useState("");
  const [itemsUsed, setItemsUsed] = useState("");
  const [itemsNotUsed, setItemsNotUsed] = useState("");
  const [climateText, setClimateText] = useState(
    langData[language].climate.profile.verySmallImpact
  );
  const [climateColor, setClimateColor] = useState("#75AC4A");

  var lastTouchEnd = 0;

  const collapse = () => {
    expandClimate[0].style.height = "100px";
    if (earthImg.classList.contains("scaled")) {
      earthImg.classList.remove("scaled");
      earthImg.classList.add("unscaled");
    }
  };

  const disableDoubleTap = (evt) => {
    const now = new Date().getTime();
    if (now - lastTouchEnd <= 300) {
      evt.preventDefault();
    }
    lastTouchEnd = now;
  };

  const handleClimateclick = () => {
    if (expandedClimate) {
      setExpandedClimate(false);
      expandClimate[0].style.height = "100px";
      earthImg.classList.remove("scaled");
      earthImg.classList.add("unscaled");
    } else {
      collapse();
      expandClimate[0].style.height = "280px";
      setExpandedClimate(true);
      earthImg.classList.remove("unscaled");
      earthImg.classList.add("scaled");
    }
  };

  useEffect(() => {
    document.addEventListener("touchEnd", (evt) => disableDoubleTap(evt));
    let climateData = calculateClimateScore(inventory);
    console.log("CLIMATE DATA: ", climateData);
    setClimateAvg(climateData.climateAvg);
    setItemsUsed(climateData.itemsUsed);
    setItemsNotUsed(climateData.itemsNotUsed);

    let tempClimateAvg = climateData.climateAvg;

    if (1.5 < tempClimateAvg && tempClimateAvg < 2.5) {
      setClimateText(langData[language].climate.profile.smallImpact);
      setClimateColor("#9DA43E");
    } else if (2.5 <= tempClimateAvg && tempClimateAvg < 3.5) {
      setClimateText(langData[language].climate.profile.impact);
      setClimateColor("#BA9E34");
    } else if (3.5 <= tempClimateAvg && tempClimateAvg < 4.5) {
      setClimateText(langData[language].climate.profile.largeImpact);
      setClimateColor("#D9982C");
    } else if (tempClimateAvg >= 4.5) {
      setClimateText(langData[language].climate.profile.veryLargeImpact);
      setClimateColor("#FA9122");
    }
    return () => {
      window.removeEventListener("touchEnd", disableDoubleTap);
    };
  }, []);

  useEffect(() => {
    if (1.5 < climateAvg && climateAvg < 2.5) {
      setClimateText(langData[language].climate.profile.smallImpact);
      setClimateColor("#9DA43E");
    } else if (2.5 <= climateAvg && climateAvg < 3.5) {
      setClimateText(langData[language].climate.profile.impact);
      setClimateColor("#BA9E34");
    } else if (3.5 <= climateAvg && climateAvg < 4.5) {
      setClimateText(langData[language].climate.profile.largeImpact);
      setClimateColor("#D9982C");
    } else if (climateAvg >= 4.5) {
      setClimateText(langData[language].climate.profile.veryLargeImpact);
      setClimateColor("#FA9122");
    }
  }, [language]);

  return (
    <div className="climateSection">
      <img
        ref={(img) => (earthImg = img)}
        id="earthIcon"
        src={earthIcon}
        alt="earthIcon"
      />
      <h5
        className="settingTitle"
        style={expandedClimate ? { color: "#74AD49" } : { color: "black" }}
      >
        {langData[language].profile.myClimateImpact}
      </h5>
      {expandedClimate ? (
        ""
      ) : (
        <p id="climateCollapseText">
          {langData[language].climate.profile.myAvg} {climateAvg}{" "}
          {langData[language].climate.profile.outOf5}
        </p>
      )}
      {expandedClimate ? (
        <div className="scoreContainer">
          <div className="row">
            <div
              className="scoreTxtContainer col-3"
              style={{ textAlign: "right" }}
            >
              <h4 style={{ color: `${climateColor}` }}>{climateAvg}</h4>
            </div>

            <div
              className="scoreTxtContainer col-3"
              style={{ textAlign: "center" }}
            >
              <p>{langData[language].profile.outOfText}</p>
            </div>
            <div
              className="scoreTxtContainer col-3"
              style={{ textAlign: "left" }}
            >
              <h4 style={{ color: "#FA9122" }}>5</h4>
            </div>
          </div>
        </div>
      ) : null}
      {expandedClimate ? (
        <div className="row">
          <div
            className="climateTxtContainer container-fluid"
            style={{ paddingLeft: "5px" }}
          >
            <p className="climateSectionText">
              {langData[language].climate.profile.usedProducts} {itemsUsed}{" "}
              {langData[language].climate.profile.outOfTotal}{" "}
              {itemsUsed + itemsNotUsed}{" "}
              {langData[language].climate.profile.productsInInventory}
            </p>
            <p className="climateSectionText">{climateText}</p>
          </div>
        </div>
      ) : (
        ""
      )}
      <Button id="showClimateInfoBtn" onClick={() => handleClimateclick()}>
        {expandedClimate
          ? langData[language].profile.showLess
          : langData[language].profile.showMore}
      </Button>
    </div>
  );
};

export default ProfileClimateModule;
